'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("abonnementAlerteService", function ($http) {
  return {
    getAlerteNouvelleVersion: function getAlerteNouvelleVersion() {
      return $http.get('/rest/abonnement-alerte/nouvelle-version').then(function (response) {
        return response.data;
      });
    },
    setAlerteNouvelleVersion: function setAlerteNouvelleVersion(statut) {
      return $http.post('/rest/abonnement-alerte/nouvelle-version?statut=' + statut).then(function (response) {
        return response.data;
      });
    },
    getAlerteNouvellePublication: function getAlerteNouvellePublication() {
      return $http.get('/rest/abonnement-alerte/nouvelle-publication').then(function (response) {
        return response.data;
      });
    },
    setAlerteNouvellePublication: function setAlerteNouvellePublication(statut) {
      return $http.post('/rest/abonnement-alerte/nouvelle-publication?statut=' + statut).then(function (response) {
        return response.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/abonnementAlerteService.js
// module id = 2864
// module chunks = 13